export default function authHeader() {
  const tmpUser = localStorage.getItem('user');
  let user = null;
  if (!tmpUser) {
    return { Authorization: '' };
  }
  user = JSON.parse(tmpUser);
  if (!user || !user.token) {
    return { Authorization: '' };
  }

  return { Authorization: 'Bearer ' + user.token };
}
